import { useRef, useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import type { Swiper as SwiperType } from 'swiper/types'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import {
  SwiperContainer,
  SwiperCover,
  DataWrapperContainer,
  NavButton,
  NavigationContainer,
} from './styled'
import DataWrapperChart from 'components/datawrapper'
const SwiperGraphs = () => {
  const [index, setIndex] = useState(0)
  const swiperRef = useRef<SwiperType>()
  const prevButton = useRef<HTMLButtonElement>(null)
  const nextButton = useRef<HTMLButtonElement>(null)

  const handleIframeLoad = () => {
    // Trigger height update when iframe finishes loading
    swiperRef.current?.updateAutoHeight?.()
  }
  useEffect(() => {
    let timeout: NodeJS.Timeout
    const handleResize = () => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        swiperRef.current?.updateAutoHeight?.()
      }, 500)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      clearTimeout(timeout)
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  return (
    <SwiperContainer>
      <Swiper
        autoHeight={true}
        spaceBetween={30}
        pagination={true}
        allowTouchMove={true}
        modules={[Navigation, Pagination]}
        onTransitionStart={(swiper) => setIndex(swiper.realIndex)}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper
        }}
      >
        <SwiperSlide>
          <DataWrapperContainer>
            <DataWrapperChart
              nomargin={true}
              title="Глобальный индекс мира и безопасности женщин за 2023 год"
              ariaLabel="Table"
              id="datawrapper-chart-L273O"
              src="https://datawrapper.dwcdn.net/L273O/5/"
              height="437px"
              onLoad={handleIframeLoad}
            />
            <SwiperCover />
          </DataWrapperContainer>
        </SwiperSlide>
        <SwiperSlide>
          <DataWrapperContainer className="right">
            <DataWrapperChart
              nomargin={true}
              title="За последние годы в Кыргызстане растет число случаев домашнего насилия"
              ariaLabel="Interactive line chart"
              id="datawrapper-chart-htCNh"
              src="https://datawrapper.dwcdn.net/htCNh/4/"
              height="425px"
            />
            <SwiperCover />
          </DataWrapperContainer>
        </SwiperSlide>
        <SwiperSlide>
          <DataWrapperContainer className="right">
            <DataWrapperChart
              nomargin={true}
              title="В Казахстане ежегодно растет количество защитных предписаний и особых требований"
              ariaLabel="Split Bars"
              id="datawrapper-chart-MvwS0"
              src="https://datawrapper.dwcdn.net/MvwS0/7/"
              height="384px"
            />
            <SwiperCover />
          </DataWrapperContainer>
        </SwiperSlide>
        <SwiperSlide>
          <DataWrapperContainer className="right">
            <DataWrapperChart
              nomargin={true}
              title="В Узбекистане большинство охранных ордеров выдавались от насилия в семье"
              ariaLabel="Donut Chart"
              id="datawrapper-chart-0mTSn"
              src="https://datawrapper.dwcdn.net/0mTSn/7/"
              height="500px"
            />
            <SwiperCover $small />
          </DataWrapperContainer>
        </SwiperSlide>
      </Swiper>
      <NavigationContainer>
        <NavButton
          ref={prevButton}
          onClick={() => swiperRef.current?.slidePrev()}
          $dir="prev"
          disabled={index < 1}
        />
        <NavButton
          ref={nextButton}
          onClick={() => swiperRef.current?.slideNext()}
          $dir="next"
          disabled={index >= 3}
        />
      </NavigationContainer>
    </SwiperContainer>
  )
}
export default SwiperGraphs
